/* Convenience guard for normal theme checkout controls; not server-side enforcement. */
(() => {
  const config = document.querySelector('[data-workshop-cart-guard]');
  if (!config) return;
  let checking = false;
  function active() {
    if (config.dataset.active === 'true') return true;
    try { return Boolean(sessionStorage.getItem('tpp-workshop-pending')); } catch { return false; }
  }
  function valid(cart) {
    const groups = new Map();
    for (const line of cart.items) {
      const id = line.properties?._registration_id;
      if (!id) continue;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(line);
    }
    return [...groups.values()].every((lines) => {
      const main = lines.find((line) => line.properties._registration_role === 'duo');
      if (!main || main.quantity !== 1) return false;
      const extra = main.properties['Extra kind geselecteerd'] === 'ja';
      if (!extra) return lines.length === 1;
      const child = lines.find((line) => line.properties._registration_role === 'extra');
      return lines.length === 2 && child?.quantity === 1 && child.parent_relationship?.parent_key === main.key;
    });
  }
  async function guard(event, button) {
    if (!active()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const response = await fetch(`${config.dataset.root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error();
      if (!valid(await response.json())) {
        throw new Error('Je workshopinschrijving is onvolledig of het aantal tickets is gewijzigd. Verwijder de volledige inschrijving en schrijf je opnieuw in via de workshoppagina.');
      }
      window.location.assign(`${config.dataset.root}checkout`);
    } catch (error) {
      let message = document.getElementById('WorkshopCartError');
      if (!message) {
        message = document.createElement('p');
        message.id = 'WorkshopCartError';
        message.setAttribute('role', 'alert');
        message.tabIndex = -1;
        button.insertAdjacentElement('beforebegin', message);
      }
      message.textContent = error.message || 'De winkelmand kon niet worden gecontroleerd. Controleer je verbinding en probeer opnieuw.';
      message.focus();
    } finally { checking = false; }
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (button) guard(event, button);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action$="/cart"]') && !event.target.closest('workshop-registration')) {
      const button = event.submitter || event.target.querySelector('[name="checkout"]');
      if (button?.name === 'checkout') guard(event, button);
    }
  }, true);
})();
